// Explicit handling for deliberately un-awaited promises (replaces `void p`).
// Callers handle their own errors; this only surfaces one that slips through
// (as a window error event) instead of an unhandled rejection.
const floating = (promise: Promise<unknown>): void => {
  promise.catch((error: unknown) => {
    window.reportError?.(error);
  });
};

export default floating;
